import React from 'react';
import { 
    Filter,
    List, 
    Datagrid,
    TextField, 
    TextInput,
} from 'react-admin';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import frequent from '../controls/Frequency';
import withStyles from '@material-ui/core/styles/withStyles';
import { stringify } from 'query-string';
import GetInstAlert from './GetInstAlert';
import ErrorBoundary from '../ErrorBoundary';

const styles = {
    link: {
        display: 'inline-flex',
        alignItems: 'center'
    },
};

const    InsFilter = props => (
    <Filter {...props}>
        <TextInput source="name" alwaysOn label='Search by Name'/>
        <TextInput source="ins_id" label="ID" />
        <TextInput source="serial_num" label="Serial #" />
    </Filter>
);

const GetFrequencyText=(freq)=>{
    var result = '';
    for(var item of frequent) {
        if(item.id === freq) {
            result = item.name;
            break;
        }
    }
    return result;
}


const GetAlert=(freq, code, ins_id)=>{
    for(var item of frequent) {
        if(freq === 'a') {
            return <GetInstAlert code={'cal_' + code + '_' + freq + '~' + ins_id}   />;
        }
    }
    return <></>
}

const Frequency = ({classes, record})=>{
    let freq = record && record.cal_frequency ? JSON.parse(record.cal_frequency) : [];
    let ins_id = record && record.ins_id ? record.ins_id : '';
    let code = record && record.code ? record.code : '';
   // console.log(freq)
    return(
        <ErrorBoundary>  
        <>
        {
            freq.map((item, key)=>(

                frequent.map((frItem)=>( frItem.id === item? 
                <>
                <Button size="small" color= "primary"  component={Link} key ={key+code+item}
                        to={{
                            pathname: `/cal_${code}_${item}`,
                            search: stringify({
                                page: 1,
                                perPage: 25,
                                sort: 'ins_id',
                                order: 'DESC',
                                filter: JSON.stringify({ ins_id: ins_id }),
                            }),
                        }}
                        className={classes.link}
                >{GetFrequencyText(item)}</Button>{GetAlert(item, code, ins_id)} </>: null
                )
              )
            )
        )
        }
        </>
        </ErrorBoundary>  
    )   
}



export const InsList = ({classes, ...props }) => (
    <List 
        {...props}
        filters={<InsFilter />}
        perPage={20}
        bulkActionButtons ={false}
        title ="Calibration"
        >
        <Datagrid >
            <TextField source="name" label="Name" />
            <TextField source="ins_id" label="ID" />
            <TextField source="serial_num" label="Serial #" />
            <Frequency classes={classes} />
        </Datagrid>
    </List>
);


export default withStyles(styles)(InsList)
